import { configureStore } from "@reduxjs/toolkit";
// settings
import settings from "../features/settings/Slice";

// auth
import auth from "../features/auth/Slice";

// common
import common from "../features/admin/common/Slice";

// masters
import masters from "./masters";

// Dashboard
import dashboard from "./dashboard";

//usermanagement
import usermanagement from "./usermanagement";

//courses
import courses from "./courses";

//internship
import internship from "./internship";

//auth
import autho from "./autho";

//studentapplication
import studentapplication from "./studentapplication";

//ticketraise
import ticketraise from "./ticketraise";

// Website
import website from "./website";

// Contactus
import contact_us from "./contact_us";

// need Advice
import need_advice from "./need_advice";

// Common otp
import commonotp from "./common";

// College Register
import college_registration from "./college_registration";

//store
export const store = configureStore({
  reducer: {
    // settings
    settings: settings,
    //auth
    auth: auth,
    //common
    common: common,
    //masters
    masters,
    // dashboard
    dashboard,
    //usermanagement
    usermanagement,
    //courses
    courses,
    //internship
    internship,
    //autho
    autho,
    //student
    studentapplication,
    //ticketraise
    ticketraise,
    //  website,
    website,

    //  contact_us,
    contact_us,

    //  need_advice,
    need_advice,

    // common
    commonotp,

    //  college_registration,
    college_registration,
  },
});
